import { UserRole } from 'domain/common'

export const isUserHaveRequiredRoles = (roles: UserRole[]) => {
  return (
    roles.includes(UserRole.admin) || roles.includes(UserRole.bookingUser) || roles.includes(UserRole.cacheRefresher)
  )
}
